export function queryParser(queryString) {
  let object = {};
  let queryArray = queryString.replace("?", "").split("&");
  queryArray = queryArray.map((query) => query.split("="));
  for (let i = 0; i < queryArray.length; i++) {
    object[queryArray[i][0]] = queryArray[i][1];
  }
  return object;
}
